import './myglobals'
import 'bootstrap/dist/css/bootstrap.css';
import { ThemeProvider } from '@fluentui/react';
import React from 'react';
import ReactDOM from 'react-dom';
import { AzureAD, AuthenticationState } from 'react-aad-msal';
import { authProvider } from './authProvider';
import { AuthCtxProvider } from './AuthCtxProvider';

import { App } from './App';
import registerServiceWorker from './registerServiceWorker';
import { BrowserRouter } from 'react-router-dom';
import { Button, Container } from 'reactstrap';

import { AuthInfo } from './AuthInfo.js'
import { initializeIcons } from '@fluentui/react';
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
initializeIcons();
ReactDOM.render(
  <ThemeProvider>
    <AzureAD provider={authProvider} forceLogin={false}>
      {
        ({ login, logout, authenticationState, error, accountInfo }) => {
          AuthInfo.logout = logout;
          AuthInfo.login = login;

          switch (authenticationState) {
            case AuthenticationState.Authenticated:
              AuthInfo.loggedIn = true;
              return (<BrowserRouter basename={baseUrl}>
                <AuthCtxProvider>
                  <App />
                </AuthCtxProvider>
              </BrowserRouter>);
            case AuthenticationState.Unauthenticated:
              if (error) {
                console.log(error);
                debugger;
              }
              return (
                <Container>
                  <div><img src="/NettechLogo.png" style={{ display: "block", marginLeft: "Auto", marginRight: "Auto", marginTop: "50px", marginBottom: "80px" }} /></div>

                  <p style={{ textAlign: "center" }}>In order to access reports, you will need to log in with your organization's account. Click the &quot;Login&quot; button below to continue. </p>

                  <Button onClick={login} style={{ minWidth: "300px", minHeight: "50px", display: "block", marginLeft: "Auto", marginRight: "Auto" }}>Login</Button>

                  {error && <div>
                    <p>An error occurred, please try again!</p>
                    <p>{error.errorMessage}</p>

                  </div>}
                </Container>);
            case AuthenticationState.InProgress:
              return (<div><p>Login in progress...</p></div>);
            default:
              return (<div><p>Please contact the developers.  This shouldn't happen</p></div>);
          }
        }
      }

    </AzureAD></ThemeProvider>,
  rootElement);

registerServiceWorker();

